import { render, staticRenderFns } from "./inventoryManagement.vue?vue&type=template&id=423273b4&scoped=true&"
import script from "./inventoryManagement.vue?vue&type=script&lang=js&"
export * from "./inventoryManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423273b4",
  null
  
)

export default component.exports